import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/license/delete/license.delete.mutation.gql"
import type {
  LicenseDeleteMutation,
  LicenseDeleteMutationVariables,
} from "@/v2-backoffice-client/license/delete/__types__/license.delete.mutation"

type Options = MutationHookOptions<
  LicenseDeleteMutation,
  LicenseDeleteMutationVariables
>

export function useLicenseDeleteMutation(options?: Options) {
  return useMutation<LicenseDeleteMutation, LicenseDeleteMutationVariables>(
    mutation,
    options,
  )
}
